import { baseURL } from "@/axios";
import constants from "@/constants/constants";

export const copyProfileLink = function (store, type, id) {
    if (store.state.user.company_id === constants.companyPfizer) {
        navigator.clipboard.writeText(`${baseURL}/pfizer-saml/login?returnTo=${type}/${id}`);
    } else if (store.state.user.company_id === constants.companyColgate) {
        navigator.clipboard.writeText(`${baseURL}/colgate-saml/login?returnTo=${type}/${id}`);
    } else if (store.state.user.company_id === constants.companyTravelers) {
        navigator.clipboard.writeText(`${baseURL}/travelers-saml/login?returnTo=${type}/${id}`);
    } else if (store.state.user.company_id === constants.companyLloyds) {
        navigator.clipboard.writeText(`${baseURL}/lloyds-saml/login?returnTo=${type}/${id}`);
    } else if (store.state.user.company_id === constants.companyCollins) {
        navigator.clipboard.writeText(`${baseURL}/collins-saml/login?returnTo=${type}/${id}`);
} else {
        navigator.clipboard.writeText(`${document.location.origin}/${type}/${id}`);
    }
}
